export class UserAgentService {
    static isIeLowerThan11() {
        const userAgent = ((navigator && navigator.userAgent) || '').toLowerCase();

        const match = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/);
        return match != null && parseInt(match[1], 10) < 11;
    }
}
